<mat-dialog-content
    class="financials-aag-dialog"
    [ngClass]="{
        'responsive-dialog-12': monthData.length > 11,
        'responsive-dialog-9': monthData.length > 8 && monthData.length <= 11,
        'responsive-dialog-6': monthData.length > 5 && monthData.length <= 8,
        'responsive-dialog-3': monthData.length > 2 && monthData.length <= 5
    }"
    [ngStyle]="{ 'min-width': headerData.isSingleMonth ? '350px' : '' }"
>
    <div class="aag-dialog-header">
        <div class="aag-header-top">
            <div class="financial-dialog-header-area">
                <div class="financial-dialog-title">{{ headerData.title | titlecase }}</div>
                <div
                    class="financial-dialog-export"
                    *ngIf="showExportButton"
                    (click)="exportToExcel()"
                >
                    <mat-icon fontSet="far" fontIcon="fa-file-excel"></mat-icon>
                </div>
            </div>
            <div class="dialog-close">
                <i class="fas fa-times aag-dialog-fas" [mat-dialog-close]="true"></i>
            </div>
        </div>
        <div style="display: flex; justify-content: space-between">
            <div>
                <div class="header-summary-label">Amount</div>
                <div
                    class="header-summary-value"
                    [ngStyle]="{ color: headerData.value < 0 ? 'rgb(224, 0, 14)' : '' }"
                >
                    <span *ngIf="headerData.value < 0">(</span
                    >{{ math.abs(headerData.value) | currency: 'USD':'symbol':'1.0-0'
                    }}<span *ngIf="headerData.value < 0">)</span>
                </div>
            </div>
            <div style="padding-right: 24px">
                <div class="header-summary-label">{{ unitsLabel ? 'Units' : 'BPS' }}</div>
                <div
                    class="header-summary-value"
                    [ngStyle]="{ color: headerData.bps < 0 ? 'rgb(224, 0, 14)' : '' }"
                >
                    {{ headerData.bps }}
                </div>
            </div>
        </div>
    </div>
    <div class="horizontal-line"></div>
    <div
        class="month-container"
        [ngStyle]="{ 'padding-left': readableMonthData.length === 2 ? '82px' : '' }"
    >
        <div
            *ngFor="let month of readableMonthData"
            class="month-labels"
            [ngStyle]="{ 'margin-right': headerData.isSingleMonth ? '20px' : '' }"
        >
            {{ month }}
        </div>
    </div>
    <div *ngIf="isDataLoading">
        <spin-loader [type]="'spinner'" class="table-spinner"></spin-loader>
    </div>
    <div *ngIf="!isDataLoading">
        <div *ngFor="let mainData of dialogExpansionData; let indx = index">
            <mat-expansion-panel
                (opened)="mainData.hasExpanded = true"
                (closed)="mainData.hasExpanded = false"
                hideToggle
                class="mat-elevation-z0"
                [expanded]="mainData.hasExpanded"
            >
                <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'44px'">
                    <mat-panel-title>
                        <div class="aag-main-data" style="display: flex">
                            <div *ngIf="!headerData.isVolumeFunded">
                                <i class="fas fa-caret-right" *ngIf="!mainData.hasExpanded"></i>
                                <i class="fas fa-caret-down" *ngIf="mainData.hasExpanded"></i>
                            </div>
                            <div class="aag-main-data-label" style="padding-left: 4px">
                                {{ mainData.mainGroupTitle }}
                            </div>
                        </div>
                        <div style="display: flex; padding-right: 10px">
                            <div
                                *ngFor="let total of mainData.mainGroupAmountTotals; let i = index"
                                class="aag-main-data-value"
                                [ngClass]="{
                                    'hover-hyperlink':
                                        i !== mainData.mainGroupAmountTotals.length - 1 || i === 0
                                }"
                                [ngStyle]="{
                                    color: total < 0 ? 'rgb(224, 0, 14)' : '',
                                    fontWeight:
                                        i === mainData.mainGroupAmountTotals.length - 1
                                            ? 'bold'
                                            : 'normal'
                                }"
                                (click)="
                                    (i !== mainData.mainGroupAmountTotals.length - 1 || i === 0) &&
                                        navigateToDrilldown(
                                            3,
                                            mainData.mainGroupTitle,
                                            monthData[i],
                                            getPageTitle(mainData.mainGroupTitle, '')
                                        )
                                "
                            >
                                <ng-container
                                    *ngIf="mainData.isCurrency; else elseBlock"
                                    class="hover-hyperlink"
                                >
                                    <span *ngIf="total < 0">(</span
                                    >{{ math.abs(total) | currency: 'USD':'symbol':'1.0-0'
                                    }}<span *ngIf="total < 0">)</span>
                                </ng-container>
                                <ng-template #elseBlock>
                                    <span *ngIf="total < 0">(</span>{{ math.abs(total)
                                    }}<span *ngIf="total < 0">)</span>
                                </ng-template>
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <div *ngFor="let subData of mainData.subGroupData">
                        <mat-expansion-panel
                            (opened)="subData.hasExpanded = true"
                            (closed)="subData.hasExpanded = false"
                            hideToggle
                            class="mat-elevation-z0"
                        >
                            <mat-expansion-panel-header collapsedHeight="*" expandedHeight="*">
                                <mat-panel-title>
                                    <div
                                        class="aag-sub-data"
                                        style="display: flex; padding-right: 10px"
                                    >
                                        <div>
                                            <i
                                                class="fas fa-caret-right"
                                                *ngIf="!subData.hasExpanded"
                                            ></i>
                                            <i
                                                class="fas fa-caret-down"
                                                *ngIf="subData.hasExpanded"
                                            ></i>
                                        </div>
                                        <div class="aag-sub-data-label" style="padding-left: 10px">
                                            {{ subData.subGroupTitle }}
                                        </div>
                                    </div>
                                    <div style="display: flex; text-align: end">
                                        <div
                                            *ngFor="let total of subData.totals; let i = index"
                                            class="aag-sub-data-value hover-hyperlink"
                                            [ngStyle]="{
                                                color: total < 0 ? 'rgb(224, 0, 14)' : ''
                                            }"
                                            (click)="
                                                navigateToDrilldown(
                                                    2,
                                                    subData.subGroupTitle,
                                                    monthData[i],
                                                    getPageTitle(
                                                        mainData.mainGroupTitle,
                                                        subData.subGroupTitle
                                                    ),
                                                    i === subData.totals.length - 1 && i !== 0,
                                                    fromDatePeriod,
                                                    mainData.mainGroupTitle
                                                )
                                            "
                                        >
                                            <span *ngIf="total < 0">(</span
                                            >{{ math.abs(total) | currency: 'USD':'symbol':'1.0-0'
                                            }}<span *ngIf="total < 0">)</span>
                                        </div>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div>
                                <div
                                    *ngFor="let individualData of subData.individualData"
                                    style="display: flex; padding-right: 10px"
                                    class="aag-individual-data"
                                    [ngStyle]="{
                                        'justify-content': headerData.isSingleMonth
                                            ? 'space-around'
                                            : ''
                                    }"
                                >
                                    <div>
                                        <div class="aag-individual-data-label">
                                            {{ individualData.title }}
                                        </div>
                                    </div>
                                    <div style="display: flex">
                                        <div
                                            *ngFor="let data of individualData.data"
                                            class="aag-individual-data-value hover-hyperlink"
                                            [ngClass]="{
                                                'hover-hyperlink': data.total !== 0
                                            }"
                                            [ngStyle]="{
                                                color: data.total < 0 ? 'rgb(224, 0, 14)' : ''
                                            }"
                                            (click)="
                                                data.total !== 0 &&
                                                    navigateToDrilldown(
                                                        1,
                                                        data.accountName,
                                                        data.yearMonthCalendar,
                                                        getPageTitle(
                                                            mainData.mainGroupTitle,
                                                            data.accountName
                                                        ),
                                                        false,
                                                        fromDatePeriod,
                                                        mainData.mainGroupTitle,
                                                        data.accountCategory
                                                    )
                                            "
                                        >
                                            <span *ngIf="data.total < 0">(</span
                                            >{{
                                                math.abs(data.total)
                                                    | currency: 'USD':'symbol':'1.0-0'
                                            }}<span *ngIf="data.total < 0">)</span>
                                        </div>
                                        <div
                                            *ngIf="!headerData.isSingleMonth"
                                            class="aag-individual-data-value total-value hover-hyperlink"
                                            [ngStyle]="{
                                                color: individualData.total < 0 ? 'red' : ''
                                            }"
                                            (click)="
                                                navigateToDrilldown(
                                                    1,
                                                    individualData.title,
                                                    individualData.yearMonthCalendar,
                                                    getPageTitle(
                                                        mainData.mainGroupTitle,
                                                        individualData.title
                                                    ),
                                                    true,
                                                    fromDatePeriod,
                                                    mainData.mainGroupTitle,
                                                    'ALL'
                                                )
                                            "
                                        >
                                            <span *ngIf="individualData.total < 0">(</span
                                            >{{
                                                math.abs(individualData.total)
                                                    | currency: 'USD':'symbol':'1.0-0'
                                            }}<span *ngIf="individualData.total < 0">)</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </div>
</mat-dialog-content>
